import { useState, useEffect } from "react";
import React from "react";
import "../css/components/InputFecha.css";
import InputMask from "react-input-mask";
import Disclaimer from "./Disclaimer";
import { autoScrollByElemento } from "./Utilitario";

function InputFecha(props) {
  const {
    id,
    inputmode = "tel",
    disabled,
    label,
    value,
    onBlur,
    onChange,
    onClickProp,
    disablePaste,
    error,
    name,
    mensajeDisclaimer,
    typeInput = "text",
    placeholder,
    dataError,
    readonly,
    required,
    cssColorBackGround,
  } = props;
  const [stateHolder, setStateholder] = useState(placeholder);
  const [inElemento, setInElemento] = useState(false);
  const [textValue, setTextValue] = useState(value || '');
  
  useEffect(() => {
    setTextValue(value);
  }, [value]);

  function eventOnBlur(event) {
    if (onBlur) {
      onBlur(event);
    }
    setStateholder(" ");
    setInElemento(false);
  }

  function eventOnChange(event) {
    setInElemento(true);
    onChange(event);
  }

  function handlerCopy(e) {
    if (disablePaste === true) {
      e.preventDefault();
    }
  }

  function onClick(event) {
    autoScrollByElemento(event);
    if (typeInput === "date") {
      setStateholder("DD/MM/AAAA");
    }
    if (onClickProp) {
      onClickProp(event);
    }
  }

  function isDone() {
    return textValue !== "" && !error && !inElemento;
  }

  let className = cssColorBackGround ? ["bbva-input bg-sphericaSecondary"] : ["bbva-input textfield-emprendedor bg-sphericaSecondary"];
  if (disabled) {
    className = [...className, "input--disabled"];
  } else if (error) {
    className = [...className, "input--error"];
  } else if (isDone()) {
    className = [...className, "input--success"];
  }

  function clearClick() {
    setTextValue('');
    const event = {
      target: {
        value: '',
        name: name,
        id: id,
        getAttribute: (attr) => {
          switch (attr) {
            case 'data-error': return dataError;
            default: return null;
          }
        }
      },
      bubbles: true,
      cancelable: true
    };
    eventOnChange(event);
  }

  const inputProps = {
    id: id,
    name: name,
    placeholder: stateHolder ? stateHolder : " ",
    className: className.join(" "),
    onPaste: handlerCopy,
    onCopy: handlerCopy,
    inputMode: inputmode,
    onChange: eventOnChange,
    onBlur: eventOnBlur,
    onClick: onClick,
    value: textValue,
    disabled: disabled,
    readOnly: readonly,
    required: required,
    autoComplete: "off",
    type: "text",
    "data-error": dataError,
  };

  return (
    <div className="input-container-input input__wrapper  textfield-cuentas__div-item">
      <InputMask mask={textValue !== '' ? "99/99/9999" : ''} {...inputProps} />
      <label htmlFor={id} className="bbva-input-label">
        {label}
      </label>
      {textValue ? 
         <span className="deleteicon_fecha">
            <span
              style={{ color: error ? 'var(--color-dark-red)' : 'var(--color-dark-blue)' }}
              onClick={clearClick}>
              &#x2715;
            </span> 
         </span>  : ''
      }
      <aside className="flex flex-col gap-3">
        {error && 
          <Disclaimer
            className="disclamer"
            mensaje={error}
            error={error}/>
        }
        <Disclaimer
          className="disclamer"
          mensaje={mensajeDisclaimer}/>
      </aside>
    </div>
  );
}

export default InputFecha;
